import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";
import Toolstack from "./Toolstack";
import { Player } from "@lottiefiles/react-lottie-player";
import io2 from '../../Assets/lottie/programmer2.json'
import io3 from '../../Assets/lottie/programmer.json'
function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "5px" }}>
        <Col
            md={6}
           
            className="about-img"
          >
            <h1 style={{ fontSize: "2.1em", paddingTop: "20px" }}>
              Know Who <strong className="purple"> We are</strong>
            </h1>
               <Player
        src={io3}
        className="player"
        loop
        autoplay
        direction={-1}
        speed={1}
        style={{ height: '370px', width: '370px' }}
      />
          </Col>  
          <Col
            md={6}
            style={{
              justifyContent: "center",
              
            }}
          >
            
            <Aboutcard />

          </Col>
          
        </Row>
       
     

       
      </Container>
    </Container>
  );
}

export default About;
